import React from "react";

const VolLalinPerbatasan = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Volume Lalu Lintas"
        src="https://paques.jaktraffic.my.id/#/pdsshare/dashboard/view/shared?sid=154&standalone=true&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJFeHBpcmVkIjoyMDk5ODc4NDQ1LCJJZGVudGl0eSI6MTU0LCJUb2tlblR5cGUiOjB9.paHQNLT2mve_ON4cOlnul1_sqM4M7PYS76mRPOT5DvA&theme=dark" 
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default VolLalinPerbatasan;
